enum AuthType {
  Universal = 'universal',
  Email = 'email',
  External = 'external',
}

export default AuthType;
